import { Outlet } from 'react-router';
import { StaggerItem } from '@/shared/ui/animations';
import { OrganizationSettingsRail } from './OrganizationSettingsRail';

/**
 * The frame every `/admin` route renders in once the redesign is on.
 *
 * Settings is a destination you leave rather than a section you browse from, so
 * the rail takes the app sidebar's place instead of sitting beside it. That is
 * what the "back" row at the bottom of the rail is for: with the app nav gone,
 * it is the only way out.
 *
 * The rail sits on the page background rather than on a card, and bleeds to the
 * viewport edges: the inset that separates every other surface from those edges
 * is paid by the content column, whose padding is simultaneously the gap
 * between rail and content. Paying it on the root instead would push the rail
 * off x=0 and the content a step further right than the design puts it.
 *
 * The column carries no surface of its own. Each page composes its own
 * `ListPageLayout` / `PageHeader` / `ListPageBody`, as every other redesigned
 * page does.
 *
 * The rail stays up on the detail routes too. The tab bar it replaced could
 * drop away there because the app sidebar was still mounted behind it; this
 * frame replaces that sidebar, so dropping the rail as well would leave a
 * full-page form with no navigation at all.
 */
export const OrganizationSettingsLayout = () => {
  return (
    <div className="flex h-dvh bg-theme-background">
      <StaggerItem index={0} className="flex min-h-0">
        <OrganizationSettingsRail />
      </StaggerItem>
      <main className="flex min-h-0 min-w-0 flex-1 flex-col overflow-auto p-app-inset">
        <Outlet />
      </main>
    </div>
  );
};
